export const RECORDING_REQUEST_STATUSES = {
  accepted: 'accepted',
  rejected: 'rejected',
  pending: 'pending',
};
